import { TimeLogsActionTypes } from "models/actionTypes/timeLogsActionTypes";
import { ReduxConstants } from "utils/constants";

export const timeLogsApproved = (id: number): TimeLogsActionTypes => {
  return {
    type: ReduxConstants.TimeLogsActions.TIME_LOGS_APPROVED,
    payload: id,
  };
};
